/**
 * Stable portal root for flowbite `<Modal>`.
 *
 * flowbite-react (0.4.x) re-appends (moves) its portal container to `root` on
 * every render when `root` is undefined, because its internal
 * `containerRef.current.parentNode !== root` check is always true once the
 * container is mounted under `document.body`. Moving the DOM node blurs any
 * focused input inside the modal, so controlled inputs lose focus after every
 * keystroke. Passing a stable `root` makes that check false on re-render, so the
 * node is never moved and focus is preserved.
 *
 * Always pass this as the `root` prop when using flowbite's `<Modal>` directly.
 */
export const modalPortalRoot: HTMLElement | undefined =
  typeof document !== "undefined" ? document.body : undefined;
